import {Flex, Space, Tooltip} from 'antd';
import * as yup from 'yup';
import CustomCheckbox from '../components/common/CustomCheckbox';
import InfoTooltip from '../components/common/InfoTooltip';
import {
    getBoxCancelReasons, getBoxSettings,
    getBoxSuspendReasons, getCalendarSync,
    saveLeadSource,
    saveLeadStatus,
    saveLostLeadReason,
    saveTaskType, updateBox
} from '../redux/boxSlice';
import {
    closeModal,
    CREATE_USER_MODAL,
    openModal, setLoadingModal,
    SETTINGS_VALUE_MODAL, STEPPER_CONFIRM_MODAL,
    updateModalRes
} from '../redux/modalManagerSlice';
import { store } from '../redux/store';
import {APPOINTMENT, CATEGORY_SELECT, COACH_SELECT, MESSAGE_TYPE, TOAST_TYPE} from '../services/ConstHelper';
import { fetchApi } from '../services/HTTP';
import { t } from '../services/i18n';
import {updateSpaceInSelectedLocation} from "../services/ScheduleService";
import {hideLoader, setAngularPath, showLoader} from "../redux/rootManagerSlice";
import ConfirmModal from "../components/common/ConfirmModal";
import React from "react";
import AppText from "../components/common/AppText";
import MediaUpload from "../components/common/MediaUpload";
import {mediaUpdateFunctions} from "../Hooks/useMediaUpload";
import SitePurchaseLimitations
    from "../components/Structure/Schedule/Popups/SitePurchaseLimitations/SitePurchaseLimitations";
import {
    createTinyUrl,
    dbDateFormat,
    generateSiteV2Link,
    getBoxSettingProperties,
    getSessionTypeIdByName, getSyncConnection, getWhiteLabelProperties, getSortedCoachesForSyncInvite
} from "../services/Helpers";
import { sendMessageToAngular } from '../services/IframeIntegrationServices';
import SharedTimepicker from '../components/common/SharedTimepicker';
import moment from 'moment';
import { GlobalStyleAttributes } from '../styles/GlobalStyles';
import { Colors } from '../styles/Colors';
import {useSelector} from "react-redux";
import {optionalSteps} from "../components/Structure/Schedule/Popups/CreateEvent/StepOptions";
import ServiceSelection from "../components/Structure/Schedule/Popups/DirectAvailabilityLink/ServiceSelection";
import SitePixelSettings from "../components/Structure/Schedule/Popups/PixelSettings/SitePixelSettings";
import { validateAfterEmailSymbol } from '../services/validationService';
import {GlobalConsts} from "../styles/GlobalConsts";
import TextEditorTableInit from "../components/Structure/Schedule/Popups/TextEditorTableInit/TextEditorTableInit";
import {HStack, VStack} from "native-base";
import CustomSwitch from '../components/common/CustomSwitch';
import SendSyncInviteSelect from '../components/Structure/Schedule/Popups/ScheduleSettings/SettingOptions/CalendarSync/SendSyncInviteSelect';
import BrandedColorRow from '../components/common/BrandedColorRow';

const BRANDED_APP_COLOR_FIELDS = [
    {key: 'primaryColor', label: 'branded-primary-color', format: 'hex'},
    {key: 'primaryColorRGBA', label: 'branded-important-messages-bg-color', format: 'rgba'},
    {key: 'primaryColorText', label: 'branded-primary-text-color', format: 'hex'},
    {key: 'secondaryColor', label: 'branded-secondary-color', format: 'hex'},
    {key: 'secondaryColorText', label: 'branded-secondary-text-color', format: 'hex'},
    {key: 'mainTabColor', label: 'branded-bottom-menu-color', format: 'hex'},
];


export const LEAD_SOURCE_TYPE = 'leadSource'
export const LEAD_STATUS_TYPE = 'leadStatus'
export const SMS_DISPLAY_VERIFY = 'smsDisplayVerify'
export const EDIT_SPACE_NAME = 'editSpaceName'
export const EDIT_SPACE_IMAGE = 'editSpaceImage'
export const TASK_TYPE = 'taskType'
export const LOST_REASONS_TYPE = 'lostReasons'
export const CANCEL_REASONS = 'cancelReasons'
export const SUSPEND_REASONS = 'suspendReasons'
export const SITE_PURCHASE_LIMITATIONS = 'sitePurchaseLimitations'
export const SEASONS = 'seasons'
export const HUG_DESCRIPTION = 'hugDescription'
export const DIRECT_AVAILABILITY_LINK = 'directAvailabilityLink'
export const SITE_PIXEL = 'sitePixel'
export const BRANDED_APP_SETTINGS = 'brandedAppSettings'
export const RECEIPTS_EMAIL_ADDRESS = 'receiptsEmailAddress'
export const TEXT_EDITOR_TABLE_INIT = 'textEditorTableInit'
export const POP_GENERAL_NOTE = 'popGeneralNote'
export const SEND_SYNC_INVITE = 'sendSyncInvite'
export const EDIT_SYNC_SETTINGS = 'editSyncSettings'

export const SettingsValueModalOptions = () => ({
    [LEAD_SOURCE_TYPE]: {
        header: 'newLeadSource',
        onSave: async ({dispatch, val, onChange}) => {
            await dispatch(saveLeadSource({name: val.val, default: val.default, id: val.id}))
            const sources = store.getState().box.box.box_sources;
            if (!sources.find(s => s.name === val.val) && !val.id)
                throw 'save-failed';
            if(onChange) {
                onChange({value: sources.find(s => s.name === val.val)?.id || !val.id})
            } else {
                sendMessageToAngular('clear_cache_object', {key: 'boxSources'}, 'main_angular_frame_id');
            }
            dispatch(getBoxSettings())
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        validationSchema: yup.object().shape({
            val: yup.string().required()
        }),
        maxInputSize: 30,
        errorType: TOAST_TYPE,
        successText: 'added-successfully',
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue}) => <CustomCheckbox isChecked={values.default} onChange={(val) => setFieldValue('default', val)} text={t('set-as-default')} />
    },
    [LEAD_STATUS_TYPE]: {
        header: 'newLeadStatus',
        onSave: async ({dispatch, val, onChange}) => {
            await dispatch(saveLeadStatus({name: val.val, default: val.default, id: val.id}))
            const statuses = store.getState().box.box.box_statuses;
            if (!statuses.find(s => s.name === val.val) && !val.id)
                throw 'save-failed';
            if(onChange) {
                onChange({value: statuses.find(s => s.name === val.val)?.id})
            } else {
                sendMessageToAngular('clear_cache_object', {key: 'boxStatuses'}, 'main_angular_frame_id');
                dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
            }
            dispatch(getBoxSettings())
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        validationSchema: yup.object().shape({
            val: yup.string().required()
        }),
        maxInputSize: 30,
        errorType: TOAST_TYPE,
        successText: 'added-successfully',
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue}) => <CustomCheckbox isChecked={values.default} onChange={(val) => setFieldValue('default', val)} text={t('set-as-default')} />
    },
    [SMS_DISPLAY_VERIFY]: {
        header: 'insert-verification-code',
        onSave: async ({params, val, onChange, dispatch}) => {
            try {
                const res = await fetchApi('boxes/authenticateOTP', 'POST', {otp_code: val, ...params}, false, true)
                switch (res) {
                    case 1:
                        onChange('verifiedSenderID', params.sender_id)
                        dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
                        return
                    case -220:
                        throw t('wrong-otp')
                    case -370:
                        throw t('expired-otp')
                    default:
                        throw t('something-went-wrong')
                }
            } catch (error) {
                throw error
            }
        },
        validationSchema: yup.object().shape({
            val: yup.string().required()
        }),
        saveText: 'verify',
        errorType: MESSAGE_TYPE,
        successText: 'verified-success',
        footerStartIcon: {
            text: 'resend-code',
            icon: 'fa-paper-plane',
            onPress: async ({params}) => {
                const res = await fetchApi('boxes/sendOTP', 'POST', { sender_id: params.sender_id }, false, true)
                if (res === 1) return
                throw 'send-otp-failed'
            },
            onPressSuccess: 'resend-otp-success',
            onPressFail: 'resend-otp-fail'
        }
    },
    [EDIT_SPACE_NAME]: {
        header: 'editSpaceName',
        onSave: async ({dispatch, val, onChange, params}) => {
            const space = await fetchApi('spaces/updateName', 'post', {name: val, id: params.id}, false, true);
            updateSpaceInSelectedLocation(space, dispatch)
            if(onChange) onChange({name: val})
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        validationSchema: yup.object().shape({
            val: yup.string().required()
        }),
        maxInputSize: 20,
        errorType: TOAST_TYPE,
        successText: 'success-space-name-update',
    },
    [EDIT_SPACE_IMAGE]: {
        header: 'spaceImage',
        onSave: async ({dispatch, val, onChange, params}) => {
            const space = await fetchApi('spaces/updateImage', 'post', {image: val, id: params.id}, false, true);
            updateSpaceInSelectedLocation(space, dispatch)
            if(onChange) onChange({image: val})
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        additionalComponentRender: ({params, setFieldValue}) => <MediaUpload onUpload={(newImage) => setFieldValue('val', newImage?.public_id?.replace('spaces/',''))} onDelete={() => setFieldValue('val', null)} fileUrl={params?.image} mediaUpdateFunctionName={mediaUpdateFunctions.updateSpaceImage} uploadText={t('clickToUploadSpaceImage')}/>,
        hideTextInput: true,
        successText: 'savedSuccessfully',
    },
    [SITE_PURCHASE_LIMITATIONS]: {
        header: 'sitePurchaseLimitations',
        onSave: async ({dispatch, val}) => {
            const res = await fetchApi(`boxes/settings`, 'POST', {properties: val, prop_name: SITE_PURCHASE_LIMITATIONS}, false, true);
            dispatch(updateBox({settings: {...store.getState().box.box.settings, [SITE_PURCHASE_LIMITATIONS]: res?.properties}}))
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        validationSchema: yup.object().shape({
            active: yup.boolean().required(),
            sessionsPerDay: yup.number().when("active", {
                is: true,
                then: yup.number().min(0).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                otherwise: yup.number().nullable()
            })
        }),
        initialValue: (getBoxSettingProperties(SITE_PURCHASE_LIMITATIONS) ?? {active: false, sessionsPerDay: null}),
        overrideVal: true,
        additionalComponentRender: ({...rest}) => <SitePurchaseLimitations {...rest}/>,
        hideTextInput: true,
        successText: 'savedSuccessfully',
        errorType: TOAST_TYPE
    },
    [TASK_TYPE]: {
        header: 'addNewTaskType',
        onSave: async ({dispatch, val, onChange, values}) => {
            await dispatch(saveTaskType({type: val, ...values}))
            const taskTypes = store.getState().box.box.task_types;
            if (!taskTypes.find(s => s.type === val))
                throw 'save-failed';
            onChange({value: taskTypes.find(s => s.type === val)?.id})
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        validationSchema: yup.object().shape({
            val: yup.string().required(),
            check_in: yup.boolean(),
            access_control: yup.boolean()
        }),
        maxInputSize: 30,
        errorType: TOAST_TYPE,
        successText: 'added-successfully',
    },
    [LOST_REASONS_TYPE]: {
        header: 'newLostReason',
        onSave: async ({dispatch, val, onChange}) => {
            await dispatch(saveLostLeadReason({name: val.val, default: val.default, id: val.id}))
            const lostReasons = store.getState().box.box.lead_lost_reasons;
            if (!lostReasons.find(s => s.name === val.val) && !val.id)
                throw 'save-failed';
            if(onChange) {
                onChange({value: lostReasons.find(s => s.name === val.val)?.id})
            } else {
                sendMessageToAngular('clear_cache_object', {key: 'lostLeadReasons'}, 'main_angular_frame_id');

            }
            dispatch(getBoxSettings())
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        validationSchema: yup.object().shape({
            val: yup.string().required()
        }),
        maxInputSize: 20,
        errorType: TOAST_TYPE,
        successText: 'added-successfully',
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue}) => <CustomCheckbox isChecked={values.default} onChange={(val) => setFieldValue('default', val)} text={t('set-as-default')} />
    },
    [CANCEL_REASONS]: {
        header: 'cancelReasonHeader',
        onSave: async ({params, val, dispatch}) => {
            const isEditMode = params?.name;
            const boxCancelReasons = store.getState().box.box.boxCancelReasons;
            const hasDuplication = boxCancelReasons?.find(
                reason => reason.name.toLowerCase() === val.val.toLowerCase() && (!isEditMode || reason.id !== params?.id)
            );

            if (hasDuplication) throw t('cancelReasonDuplicateError');

            await fetchApi(`${isEditMode ? 'edit' : 'create'}BoxCancelReason`, 'POST', {reason: {cancel_reason_id: params.id, name: val.val, default: val.default}}, false, true)
            dispatch(setAngularPath(null));
            setTimeout(() => dispatch(setAngularPath('settings')), 100);
            dispatch(getBoxCancelReasons());
            dispatch(getBoxSettings())
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        maxInputSize: 30,
        errorType: MESSAGE_TYPE,
        successText: 'savedSuccessfully',
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue}) => <CustomCheckbox isChecked={values.default} onChange={(val) => setFieldValue('default', val)} text={t('set-as-default')} />
    },
    [SUSPEND_REASONS]: {
        header: 'suspendReasonHeader',
        onSave: async ({params, val, dispatch}) => {
            const isEditMode = params?.name;
            const boxSuspendReasons = store.getState().box.box.boxSuspendReasons;
            const hasDuplication = boxSuspendReasons?.find(
                reason => reason.name.toLowerCase() === val.val.toLowerCase() && (!isEditMode || reason.id !== params?.id)
            );

            if (hasDuplication) throw t('suspendReasonDuplicateError');

            await fetchApi(`${isEditMode ? 'edit' : 'create'}BoxSuspendReason`, 'POST', {reason: {suspend_reason_id: params.id, name: val.val, default: val.default}}, false, true)
            dispatch(setAngularPath(null));
            setTimeout(() => dispatch(setAngularPath('settings')), 100);
            dispatch(getBoxSuspendReasons());
            dispatch(getBoxSettings())
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        maxInputSize: 30,
        errorType: MESSAGE_TYPE,
        successText: 'savedSuccessfully',
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue}) => <CustomCheckbox isChecked={values.default} onChange={(val) => setFieldValue('default', val)} text={t('set-as-default')} />
    },
    [SEASONS]: {
        header: 'add-edit-season-header',
        onSave: async ({val, dispatch}) => {
            const res = await fetchApi('seasons/save', 'POST', {...val, name: val.val, start_date: val.hasDateRange ? moment(val.start_date).format(dbDateFormat) : null, end_date: val.hasDateRange ? moment(val.end_date).format(dbDateFormat) : null}, false, true)
            let seasons = [...store.getState().box?.box?.seasons];
            const updatedSeasonIndex = seasons.findIndex(season => season.id === val.id);
            if (updatedSeasonIndex !== -1) {
                let season = {...seasons[updatedSeasonIndex]};
                season.name = res.name;
                season.start_date = res.start_date;
                season.end_date = res.end_date;
                seasons[updatedSeasonIndex] = season;
            } else {
                seasons = [...seasons, {...res, active: 1}];
            }
            dispatch(updateBox({seasons}));
            dispatch(updateModalRes({modalName: SETTINGS_VALUE_MODAL, res: {...res, active: 1}}))
            sendMessageToAngular('get_from_store', {key: 'box.box.seasons', value: seasons}, 'main_angular_frame_id');
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        maxInputSize: 30,
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue, errors, touched}) => <Flex vertical style={{marginTop: '1rem'}}>
            <CustomCheckbox text={t('set-date-range')} isChecked={values.hasDateRange} onChange={(val) => setFieldValue('hasDateRange', val)} />
            {values.hasDateRange && <SharedTimepicker type={'date'} select="range" value={[moment(values.start_date, dbDateFormat), moment(values.end_date, dbDateFormat)]} onChange={(dates) =>setFieldValue('start_date', dates[0]) | setFieldValue('end_date', dates[1])} textStyle={{ fontSize: GlobalStyleAttributes.fonts.standard16 }}  />}
            {(touched.hasDateRange) && (errors.end_date || errors.start_date) && <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText} width='max-content' mediumFont>{errors.end_date || errors.start_date}</AppText>}
        </Flex>,
        errorType: TOAST_TYPE,
        validationSchema: yup.object().shape({
            val: yup.string().required(),
            start_date: yup.string().when('hasDateRange', {
                is: true,
                then: yup.string().required(t('please-choose-dates')).typeError(t('please-choose-dates')),
                otherwise: yup.string().nullable()
            }),
            end_date: yup.string().when('hasDateRange', {
                is: true,
                then: yup.string().required(t('please-choose-dates')).typeError(t('please-choose-dates')),
                otherwise: yup.string().nullable()
            }).test('date-range', t('date-range-error'), function(value) {
                return moment(value).format(dbDateFormat) >= moment(this.parent.start_date).format(dbDateFormat)
            })
        }),
        successText: 'savedSuccessfully',
    },
    [HUG_DESCRIPTION]: {
        header: 'hug-description',
        onSave: async ({val, onChange, dispatch}) => {
            onChange(val)
            dispatch(closeModal({ modalName: SETTINGS_VALUE_MODAL}))
        },
        maxInputSize: 20,
        validationSchema: yup.object().shape({
            val: yup.string().min(2, t('nameErrorMsg')).max(20, t('nameErrorMsg')).nullable(),
        }),
    },
    [DIRECT_AVAILABILITY_LINK]: {
        header: 'direct-availability-link-header',
        saveText: 'create-link',
        hideTextInput: true,
        onSave: async ({val, dispatch}) => {
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: true}))
            const selectedLocation = store.getState().userSettings.scheduleLocation;
            const siteLink = generateSiteV2Link(`staff-appointment/${val}`, {referer: 'SITE', location: selectedLocation.id});
            const tinyLink = await createTinyUrl(siteLink)
            dispatch(updateModalRes({modalName: SETTINGS_VALUE_MODAL, res: {link: tinyLink, type: DIRECT_AVAILABILITY_LINK, serviceType: val}}))
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: false}))
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))

        },
        additionalComponentRender: ({...props}) => <ServiceSelection {...props}/>,
        validationSchema: yup.object().shape({ val: yup.number().positive().integer().required(t('thisFieldIsMandatory'))})
    },
    [SITE_PIXEL]: {
        header: 'site-pixel-header',
        hideTextInput: true,
        onSave: async ({val, dispatch}) => {
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: true}))
            await fetchApi('boxes/updatePixels', 'POST', val, false, true)
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: false}))
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        additionalComponentRender: (props) => <SitePixelSettings {...props}/>,
        validationSchema: yup.object().shape({
            facebook: yup.string().nullable(),
            tiktok: yup.string().nullable(),
        }),
        overrideVal: true,
        successText: 'savedSuccessfully',
        errorType: TOAST_TYPE,
    },
    [RECEIPTS_EMAIL_ADDRESS]: {
        header: 'receiptsEmailAddress',
        inputLabel: 'email',
        onSave: async ({val, dispatch}) => {
            await fetchApi('boxes/updateReceiptsEmail', 'POST', {email: val}, false, true)
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        validationSchema: yup.object().shape({
            val: yup.string().required().email(t('emailIsInvalid')).label('Email').test('email-domains', t('invalidEmailDomain'), function(value){
                return !validateAfterEmailSymbol(value)
            }),
        }),
    },
    [BRANDED_APP_SETTINGS]: {
        header: 'branded-app-settings',
        initialValue: getWhiteLabelProperties(),
        overrideVal: true,
        onSave: async ({dispatch, val}) => {
            const res = await fetchApi('boxes/updateWhiteLabelProperties', 'POST', {properties: val}, false, true)
            dispatch(updateBox({white_label_property: res}))
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        successText: 'branded-app-settings-saved',
        additionalComponentRender: ({values, setFieldValue}) => (
            <Flex vertical style={{marginTop: '1rem'}} gap={'1rem'}>
                <CustomCheckbox text={t('auto-disconnect-inactive')} isChecked={values.authGuard} onChange={(val) => setFieldValue('authGuard', val)} />
                <CustomCheckbox text={
                    <HStack alignItems={'center'}>
                        {t('all-locations-default')}
                        <InfoTooltip title={t('all-locations-tooltip')} />
                    </HStack>
                } isChecked={values.defaultAllLocations} onChange={(val) => setFieldValue('defaultAllLocations', val)} />
                {BRANDED_APP_COLOR_FIELDS.map(({key, label, format}) => (
                    <BrandedColorRow
                        key={key}
                        fieldKey={key}
                        label={label}
                        initialFormat={format}
                        value={values[key]}
                        setFieldValue={setFieldValue}
                    />
                ))}
            </Flex>
        ),
        hideTextInput: true,
    },
    [TEXT_EDITOR_TABLE_INIT]: {
        header: 'init-table',
        initialValue: {rows: null, columns: null, headerRow: false, headerColumn: false},
        overrideVal: true,
        saveText: 'create-table',
        hideTextInput: true,
        validationSchema: yup.object().shape({
            rows: yup.number().min(1).max(50, t('max-rows', {max: 50})).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            columns: yup.number().min(1).max(20, t('max-columns', {max: 20})).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            headerRow: yup.boolean(),
            headerColumn: yup.boolean()
        }),
        onSave: async ({val, dispatch}) => {
            dispatch(updateModalRes({modalName: SETTINGS_VALUE_MODAL, res: {values: val, type: TEXT_EDITOR_TABLE_INIT}}))
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        additionalComponentRender: (props) => <TextEditorTableInit {...props}/>

    },
    [POP_GENERAL_NOTE]: {
        header: 'popNoteConfirmHeader',
        hideTextInput: true,
        overrideVal: true,
        successText: 'savedSuccessfully',
        onSave: async ({dispatch, val}) => {
            //pop = 1 -> show in user profile and in appointment manage
            //pop = 2 -> show only in user profile
            //pop = 3 -> show only in appointment manage
            let pop = (val.profile && val.manage) ? 1 : (val.profile ? 2 : (val.manage ? 3 : 0))
            await fetchApi('notes/togglePopNote', 'POST', {note: {...val, pop}}, false, true)
            sendMessageToAngular('refresh_general_notes', {}, 'main_angular_frame_id')
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        additionalComponentRender: ({values, setFieldValue}) => (
        <VStack space={'0.5rem'}>
            <AppText>{t('popNoteConfirmSubHeader')}</AppText>
            <VStack space={'0.2rem'}>
                <CustomCheckbox text={t('pop-note-user-profile-checkbox')} isChecked={values.profile} onChange={(val) => setFieldValue('profile', val)} />
                <CustomCheckbox text={t('pop-note-appointment-manage-checkbox')} isChecked={values.manage} onChange={(val) => setFieldValue('manage', val)} />
            </VStack>
        </VStack>
        )

    },
    [SEND_SYNC_INVITE]: {
        header: 'send-sync-invite-header',
        onSave: async ({val, dispatch}) => {
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: true}))
            // If 'all' is selected, get all valid coaches (those not disabled)
            let usersBoxesIds;
            const hasAll = val.users_boxes?.some(item => item.value === 'all');

            if (hasAll) {
                // Get all coaches with valid emails (exclude disabled ones)
                const allValidCoaches = getSortedCoachesForSyncInvite()
                    .filter(coach => coach.value !== 'all' && !coach.isDisabled)
                    .map(coach => coach.ub_id);
                usersBoxesIds = allValidCoaches;
            } else {
                usersBoxesIds = val.users_boxes.map(userBox => userBox.ub_id);
            }

            await fetchApi('calendarSyncConnections/sendInvitation', 'POST', {users_boxes_ids: usersBoxesIds}, false, true)
            dispatch(getCalendarSync());
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: false}))
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        successText: 'sync-invite-sent-successfully',
        hideTextInput: true,
        showCancelButton: true,
        saveText: t('send'),
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue, touched, errors, ...rest}) =>
            <SendSyncInviteSelect
                values={values}
                setFieldValue={setFieldValue}
                touched={touched}
                errors={errors}
            />

    },
    [EDIT_SYNC_SETTINGS]: {
        header: 'edit-sync-settings',
        onSave: async ({val, dispatch}) => {
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: true}))
            await fetchApi('calendarSyncConnections/syncSettings', 'POST', val, false, true)
            dispatch(getCalendarSync());
            dispatch(setLoadingModal({modalName: SETTINGS_VALUE_MODAL, isConfirmLoading: false}))
            dispatch(closeModal({modalName: SETTINGS_VALUE_MODAL}))
        },
        hideTextInput: true,
        showCancelButton: true,
        initialValue: getSyncConnection(),
        overrideVal: true,
        additionalComponentRender: ({values, setFieldValue}) => {
            const showCheckForConflicts = store.getState().box.box.show_check_for_conflicts;
            return <VStack space={'1rem'}>
                {showCheckForConflicts && <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <VStack space={'0.25rem'} width={'90%'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16}
                                 boldFont>{t('check-for-conflicts')}</AppText>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} style={{
                            textOverflow: 'ellipsis',
                            overflow: 'hidden'
                        }}>{t('check-for-conflicts-txt')}</AppText>
                    </VStack>
                    <CustomSwitch isChecked={values.check_for_conflicts}
                                  onToggle={(val) => setFieldValue('check_for_conflicts', val)}/>
                </HStack>}
                <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <VStack space={'0.25rem'} width={'90%'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('add-to-calendar')}</AppText>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>{t('add-to-calendar-txt')}</AppText>
                    </VStack>
                    <CustomSwitch isChecked={values.add_to_calendar} onToggle={(val) => setFieldValue('add_to_calendar', val)}/>
                </HStack>
            </VStack>;
        },
    }
})